<template>
    <div id="content">
        <div class="container">
            <div id="page-header-fixed" class="mb-25">
                <div class="container">
                    <div id="page-header" class=" gap-3 flex-wrap">
                        <NavTabs :user_info="user_info"></NavTabs>
                    </div>
                </div>
            </div>

            <div id="unit-detail" class="card card-comments">
                <div class="card-body">
                    <h5 class="card-title">
                        <span class="title">{{ $t('notifications') }}</span>
                    </h5>
                    <div class="card-content d-flex flex-column gap-3" v-if="comments.length">
                        <div class="comment shadow-sm" v-for="comment in comments">
                            <div class="comment-header">

                            </div>
                            <div class="comment-body">
                                <h4 class="title">{{ $t('daily_comment_title') }}</h4>
                                <p><strong>{{ comment.lesson_name }}:</strong> {{ moment(comment.study_date, 'YYYY-MM-DD').format('DD/MM/YYYY') + ', ' + comment.start_hour + ' - ' + comment.end_hour }}</p>
                                <p><strong>{{ $t('daily_comment_teacher') }}:</strong> {{ comment.teacher_name }}</p>
                                <h4 class="title mt-3">{{ $t('daily_comment_content') }}</h4>
                                <p class="my-2">{{ comment.commentVI }}</p>
                                <p class="fst-italic">{{ comment.comment }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="card-content d-flex flex-column gap-3" v-else>
                        <div class="d-flex flex-column">
                            <div class="text-center text-bold mb-3">
                                {{ $t('empty_data') }}
                            </div>
                            <img class="m-auto" src="/themes/ito/images/notification-empty.svg" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import NavTabs from "./components/NavTabs"
import moment from "moment";

export default {
    name: "ParentDailyComment",
    components: { NavTabs },

    data() {
        return {
            comments: []
        };
    },

    created() {
        this.fetch();
    },
    computed: {
        user_info() {
            return this.$store.state.user_info;
        },
    },
    methods: {
        async fetch() {
            const vm = this;
            const url = process.env.VUE_APP_ECO_URL + "/api_eco.php/getCommentByClass";
            const params = {
                // class_id: 1344,
                // student_id: 23603
                class_id: this.user_info.eco_class_id,
                student_id: this.user_info.eco_user_id
            };
            this.$store.commit("setLoading", true);

            await axios.get(url, { params })
                .then(function (response) {
                    if (response.status == 200) {
                        var results = response.data.data
                        vm.comments = results.filter((item) => item.comment != '').sort((a, b) => moment(b.study_date).unix() - moment(a.study_date).unix());
                    }
                })
                .catch(function (error) {
                    console.error(error);
                });
            this.$store.commit("setLoading", false);
        },
    }
}
</script>

<style scoped>
.comment {
    border: 2px solid #0000001A;
    border-radius: 8px;
    background: #FFFFFF;
    display: flex;
    flex-direction: column;
    padding: 12px 20px;
}

.comment-header {
    display: flex;
    justify-content: space-between;
}

.comment-header .title,
.comment-body .title {
    font-size: 16px;
    font-weight: 700;
    text-align: left;
    margin: 0;
}

.comment-body p {
    font-size: 14px;
    font-weight: 400;
    text-align: left;
    white-space: pre-line;
    color: #070A28;
}
</style>
